import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import appRoutes from "@/routes";
import { useAuth } from "@/auth/AuthContext";

const Logout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      await logout();
      navigate(appRoutes.public.login, { replace: true });
    };
    performLogout();
  }, [logout, navigate]);

  return null;
};

export default Logout;
